import { render, staticRenderFns } from "./ordstatisticsdatatime.vue?vue&type=template&id=aae2367c&"
import script from "./ordstatisticsdatatime.vue?vue&type=script&lang=ts&"
export * from "./ordstatisticsdatatime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ordstatisticsdatatime.vue"
export default component.exports